import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GoalScoreCard } from "./goalScoreCard";
import goalScoreService from "../../../api/services/goalScoreService";
import * as moment from "moment";
import DatePicker from "react-datepicker";
import { useMemo } from "react";
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { FiSearch } from "react-icons/fi";
import sortArrow from '../../../assets/newIcons/sorting-arrows.png';
import { BiSolidCalendar } from "react-icons/bi";
import { MdCancel } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";

export const GoalScore = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [goalScore, setgoalScore] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [sortBy, setSortBy] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [filteredGoalScore, setFilteredGoalScore] = useState([]);
  //eslint-disable-next-line
  const navigate = useNavigate();

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleBackClick = () => {
    handleSongClick();
    navigate("/dashboard");
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const filteredData = goalScore.filter(item => {
      const searchTerm = searchInput?.toLowerCase();
      return (
        item.league.toLowerCase().includes(searchTerm) ||
        item.homeTeam.toLowerCase().includes(searchTerm) ||
        item.homeTeamMyan.toLowerCase().includes(searchTerm) ||
        item.awayTeam.toLowerCase().includes(searchTerm) ||
        item.awayTeamMyan.toLowerCase().includes(searchTerm)
      )
    }
    );
    setFilteredGoalScore(filteredData);
  }, [searchInput, goalScore]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    getData(date);
  };

  const handleSearchClick = async () => {
    await handleSongClick();
    setShowSearch(!showSearch);
  };

  const handleSearchInputChange = useCallback((event) => {
    setSearchInput(() => event.target.value);
  }, []);

  const handleClearSearch = () => {
    handleSongClick();
    setSearchInput('');
    setShowSearch(false);
  };

  const getData = (date = selectedDate) => {
    setIsLoading(true);
    goalScoreService
      .goalScores({
        startDate: moment(new Date(date)).format("YYYY-MM-DD"),
        endDate: moment(new Date(date)).format("YYYY-MM-DD"),
      })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          const teamData = data?._data.map((item) => item.team).flat();
          setgoalScore(() => teamData);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API request error:", err);
      });
  };

  const sortedGoalScore = useMemo(() => {
    const sortedData = [...filteredGoalScore];
    if (sortBy) {
      sortedData.sort((a, b) => new Date(b.event) - new Date(a.event));
    } else {
      sortedData.sort((a, b) => new Date(a.event) - new Date(b.event));
    }
    return sortedData;
  }, [filteredGoalScore, sortBy]);

  const handleSortingMatches = () => {
    setSortBy((preSort) => !preSort);
  };

  return (
    <div className="w-full h-screen flex flex-col bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10 relative">

      {/* Header */}
      <div className="relative z-40 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] py-4 px-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <button
              className="flex items-center justify-center w-10 h-10 mr-4 text-white rounded-xl active:bg-white/20"
              onClick={handleBackClick}
            >
              <IoIosArrowBack size={25} />
            </button>
            {!showSearch && (
              <div>
                <h3 className="text-xl font-bold text-white">{t("goalScore")}</h3>
                <p className="text-xs font-medium text-emerald-100">Match Results & Scores</p>
              </div>
            )}
          </div>

          {/* Search Input */}
          {showSearch && (
            <div className="flex-1 mx-4">
              <div className="relative">
                <input
                  type="text"
                  className="w-full bg-white border border-gray-200 rounded-2xl py-3 pl-12 pr-12 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#FFD700] font-medium"
                  placeholder="Search teams, leagues..."
                  value={searchInput}
                  onChange={handleSearchInputChange}
                />
                <FiSearch size={20} className="absolute text-gray-500 transform -translate-y-1/2 left-4 top-1/2" />
                <button
                  className="absolute text-gray-500 transform -translate-y-1/2 right-4 top-1/2"
                  onClick={handleClearSearch}
                >
                  <MdCancel size={22} />
                </button>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex items-center space-x-2">
            {!showSearch && (
              <>
                <label htmlFor="goalScoreDate" className="flex items-center justify-center w-10 h-10 text-white rounded-xl active:bg-white/20 cursor-pointer">
                  <BiSolidCalendar size={24} />
                </label>
                <DatePicker
                  id="goalScoreDate"
                  selected={selectedDate || new Date()}
                  onChange={handleDateChange}
                  dateFormat="yyyy-MM-dd"
                  withPortal
                  closeOnSelect={true}
                  className="hidden w-2 text-transparent text-white border-none h-9 bg-inherit focus:outline-none"
                />

                <button
                  className="flex items-center justify-center w-10 h-10 text-white rounded-xl active:bg-white/20"
                  onClick={handleSortingMatches}
                >
                  <img src={sortArrow} alt="Sort" className="w-6 h-6 filter brightness-0 invert" />
                </button>
              </>
            )}

            <button
              onClick={handleSearchClick}
              className="flex items-center justify-center w-10 h-10 text-white rounded-xl active:bg-white/20"
            >
              <FiSearch size={22} />
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 overflow-auto bg-white/50">
        <GoalScoreCard data={sortedGoalScore} />
      </div>
    </div>
  );
};
